import { useState } from 'react';
import CollapsibleSection from '../../atoms/CollapsibleSection';
import OrgManagement from './OrgManagement';
import OrgOnboardSection from './OrgOnboardSection';
import './Workshop.scss';
import Page from '../../atoms/Page';

export default function WorkshopPage() {
  const [org, setOrg] = useState();
  return (
    <Page heading="James' Workshop" className="Workshop">
      <CollapsibleSection title="Org Onboarding" isExpanded={false} headerClassName="Workshop-header">
        <OrgOnboardSection onCreate={setOrg} wrapperClassName="Workshop-section" />
      </CollapsibleSection>
      <hr />
      <CollapsibleSection title="Org Access Viewer" isExpanded={false}>
        <OrgManagement orgObject={org} wrapperClassName="Workshop-section" />
      </CollapsibleSection>
      <hr />
    </Page>
  );
}
